// extracted by mini-css-extract-plugin
export default {"borderBottom":"mMm0Q9irp9XNNfCmsEfL"};